import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'a'>,
  {
    href?: string
    icon: React.ReactNode
    label: string
    active?: boolean
    collapse?: boolean
    onClick?: (event: React.MouseEvent, href: string) => void
  }
>

const NavigationLink = ({
  className,
  href = '#',
  icon,
  label,
  active = false,
  collapse = false,
  onClick,
  ...props
}: Props) => {
  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault()

    if (onClick) {
      onClick(event, href)
    }
  }

  return (
    <a
      {...props}
      className={cn(
        'NavigationLink',
        {
          active,
          collapse,
        },
        className
      )}
      title={collapse ? label : undefined}
      href={href}
      onClick={handleClick}
    >
      <div className="NavigationLink__label">
        <span className="NavigationLink__icon">{icon}</span>
        <span className="NavigationLink__text">{label}</span>
      </div>
    </a>
  )
}

export default NavigationLink
